'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/prop-types-extra/~/react-is/index.js
// module id = 1520
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16